import LinkMenu from './_link-menu.js'
import Hideable from './_hideable.js'

export default {
  name: 'GlobalLinks',
  values: {
    links: undefined,
    linkMenu: {
      configSet: LinkMenu,
      configValues: {
        regularItem: {
          unselected: {
            style: {
              base: {
                padding: '12px 8px',
              },
            },
          },
          selected: {
            style: {
              base: {
                padding: '12px 8px',
              },
            },
          },
        },
      },
    },
    $mixin: [
      {
        configSet: Hideable,
      },
    ],
  },
  meta: {
    extendable: false,
  },
}
